import React, { useEffect, useState } from "react";
import OtpInput from "../input/otpInput";
import OtpDescription from "../other/otpDescription";
import CreateOTP from "../../functions/user/createOTP";
import { Modal } from "antd";
import { useUser } from "../../screens/user/context.js/userContext";

const OtpVerifier = ({ open, close, userId, verified, show = false }) => {
  const [otpData, setOtpData] = useState(null);
  const [code, setCode] = useState("");
  const [phone, setPhone] = useState("");
  const [wrongAttempt, setWrongAttempt] = useState(false);
  const { setPaying } = useUser();
  useEffect(() => {
    if (userId) getOtp();
  }, [userId]);
  const getOtp = async () => {
    setPaying("Утасны дугаарын баталгаажуулалт хийгдэж байна...");
    const data = await CreateOTP(userId);
    setPaying(null);
    if (data) {
      //NotificationSuccess({message:data.code})
      setOtpData(data);
      setPhone(data.phone);
    }
  };
  const maskedPhone = phone ? (show ? phone : phone.slice(0, -4) + "****") : "";
  const codeChange = (e) => {
    setCode(e);
    if (otpData && e && e === String(otpData.code)) {
      verified();
    } else if (e.length === 4) shake();
  };
  const shake = () => {
    setWrongAttempt(true);
    setTimeout(() => {
      setWrongAttempt(false);
    }, 500);
  };
  return (
    <Modal open={open} size={350} footer={null} onCancel={close}>
      <div className="">
        <div className="addCarTitle">
          <span>Та утасны дугаараа баталгаажуулна уу</span>
        </div>
        <OtpDescription phone={maskedPhone} />
        <OtpInput value={code} wrong={wrongAttempt} onChange={codeChange} />
      </div>
    </Modal>
  );
};

export default OtpVerifier;
